import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {}, [_c('div', {
    staticClass: "search-detail",
    style: {
      height: _vm.detailShow ? _vm.height + 4 + "rem" : '0'
    }
  }, [_c('div', {
    staticClass: "search-detail-content",
    style: {
      height: _vm.height + "rem"
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "search-detail-button"
  }, [_c('div', {
    staticClass: "search-detail-button-left",
    on: {
      "click": function ($event) {
        return _vm.$emit('on-reset');
      }
    }
  }, [_c('XButton', {
    attrs: {
      "action-type": "button",
      "type": "default"
    }
  }, [_vm._v(i18n.tc("344"))])], 1), _c('div', {
    staticClass: "search-detail-button-right",
    on: {
      "click": function ($event) {
        _vm.$emit('on-detail-ok'), _vm.detailShow = false;
      }
    }
  }, [_c('XButton', {
    attrs: {
      "type": "primary",
      "action-type": "button"
    }
  }, [_vm._v(i18n.tc("12"))])], 1)])]), _c('div', {
    staticClass: "mask",
    style: {
      opacity: _vm.detailShow ? '.5' : '0',
      zIndex: _vm.detailShow ? '2' : '-1',
      display: _vm.detailShow ? '' : 'none'
    },
    on: {
      "click": function ($event) {
        _vm.detailShow = false;
      }
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };